import { defineTheme } from "@astryxdesign/core/theme";
import { neutralTheme } from "@astryxdesign/theme-neutral";

/**
 * Shared theme for the micro-tools (ip, s, json, regex, diff, epoch).
 *
 * Same neutral base + soft-pink accent as hq, so every karrtopelka surface outside the
 * games reads as one family. Tools are content-first: the palette stays quiet and the
 * accent is reserved for the one value the visitor came for.
 */
export const toolsTheme = defineTheme({
  name: "tools",
  extends: neutralTheme,
  tokens: {
    "--color-accent": ["#d94f82", "#ff6fa5"],
    "--color-accent-muted": ["#ff6fa533", "#ff6fa540"],
    "--color-text-accent": ["#bc3a6a", "#ff9ec6"],
    "--color-icon-accent": ["#d94f82", "#ff6fa5"],
    "--color-background-body": ["#f7f3f5", "#0b0b0c"],
    "--color-background-surface": ["#ffffff", "#161618"],
    "--color-background-popover": ["#ffffff", "#1f1f22"],
  },
});
